import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import DisplayPromoCode from '../src/DisplayPromoCode';

import get from 'lodash.get';

const ItemDisplayPromoCodeWrapper = props => (
    <DisplayPromoCode
        {...props}
        promotion={get(props, 'item.activePromotion') || null}
        item={get(props, 'item') || null}
        user={get(props, 'user') || null}
    />
);

ItemDisplayPromoCodeWrapper.propTypes = {
    user: PropTypes.object,
    item: PropTypes.object,
    isFurtherReduced: PropTypes.bool,
    displaySingleLine: PropTypes.bool,
    containerClass: PropTypes.string,
    promoDisplayClass: PropTypes.string,
    seeDetailsClass: PropTypes.string,
    hideDetails: PropTypes.bool,
};

export default createFragmentContainer(ItemDisplayPromoCodeWrapper, {
    user: graphql`
        fragment ItemDisplayPromoCodeWrapper_user on User {
            ...DisplayPromoCode_user
        }
    `,
    item: graphql`
        fragment ItemDisplayPromoCodeWrapper_item on Item {
            ...DisplayPromoCode_item
            activePromotion(userId: $userId) {
                ...DisplayPromoCode_promotion
            }
        }
    `,
});
